import baseApi from '../api/baseApi'

const publishedReleaseNotesApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchPublishedReleaseNotes: builder.query({
      query: () => 'release',
    }),
  }),
  overrideExisting: true,
})

export const { useFetchPublishedReleaseNotesQuery } = publishedReleaseNotesApi

export default publishedReleaseNotesApi
